import { render, staticRenderFns } from "./functionGrant.vue?vue&type=template&id=15db2019&scoped=true&"
import script from "./functionGrant.vue?vue&type=script&lang=ts&"
export * from "./functionGrant.vue?vue&type=script&lang=ts&"
import style0 from "./functionGrant.vue?vue&type=style&index=0&id=15db2019&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15db2019",
  null
  
)

export default component.exports